import script from "./Lead.vue?vue&type=script&setup=true&lang=js"
export * from "./Lead.vue?vue&type=script&setup=true&lang=js"

import "./Lead.vue?vue&type=style&index=0&id=37349da0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37349da0"]])

export default __exports__